// extracted by mini-css-extract-plugin
export default {"space":"styles_space__Ingcd","icon":"styles_icon__tUG8Y","text":"styles_text__9TK2P","selected":"styles_selected__KBacl"};